import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CogDoubleSvg = function CogDoubleSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.206 5.664a1.13 1.13 0 0 0-1.6 0 1.14 1.14 0 0 0 0 1.61 1.13 1.13 0 0 0 1.6 0 1.14 1.14 0 0 0 0-1.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.93 2h-3.054l-.367 1.157-1.18-.258-1.522 2.651.786.91-.785.91 1.52 2.65 1.18-.258.368 1.157h3.056l.367-1.157 1.18.258L22 7.37l-.786-.91.787-.91L20.478 2.9l-1.18.258zm-2.48 2.796.443-1.395h1.02l.444 1.395 1.424-.311.516.9-.93 1.075.93 1.075-.516.899-1.424-.312-.443 1.396h-1.02l-.444-1.396-1.424.312-.516-.9.929-1.075-.93-1.074.517-.9zM7.147 14.183a1.99 1.99 0 0 1 2.826 0 2.017 2.017 0 0 1 0 2.843 1.99 1.99 0 0 1-2.826 0 2.017 2.017 0 0 1 0-2.843m1.413.812a.604.604 0 0 0-.606.61.61.61 0 0 0 .606.609.604.604 0 0 0 .606-.61.61.61 0 0 0-.606-.61",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.449 9.208h4.222v1.587c.343.152.67.342.972.565l1.367-.793 2.11 3.679-1.366.793q.06.566 0 1.13l1.367.793-2.113 3.68-1.365-.794a5.2 5.2 0 0 1-.972.566V22H6.45v-1.586a5.2 5.2 0 0 1-.972-.565l-1.366.793L2 16.962l1.365-.793a5.3 5.3 0 0 1 0-1.13L2 14.246l2.111-3.68 1.366.794q.456-.335.972-.565zM7.84 10.61v1.172l-.478.158a3.8 3.8 0 0 0-1.356.79l-.376.338-1.01-.587-.719 1.252 1.008.586-.103.496a3.9 3.9 0 0 0 0 1.578l.103.496-1.008.586.719 1.253 1.01-.587.376.339c.393.354.855.622 1.356.788l.478.159v1.172H9.28v-1.172l.478-.159a3.8 3.8 0 0 0 1.356-.789l.376-.339 1.01.588.72-1.253-1.01-.585.103-.497a3.9 3.9 0 0 0 0-1.578l-.103-.496 1.009-.586-.719-1.253-1.01.587-.376-.338a3.8 3.8 0 0 0-1.356-.789l-.478-.158V10.61z",
    clipRule: "evenodd"
  }));
};
export var CogDouble = function CogDouble(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CogDoubleSvg
  }));
};